import React from 'react';
import { Flex, Progress, Typography } from 'antd';
import _ from 'lodash';

const ChecklistProgress = ({ trackCheckList, justify }) => {
    const completedCount = _.size(
        _.filter(trackCheckList, (item) => item.status === true || item.status === 1)
    );

    if (!trackCheckList || trackCheckList.length === 0) return null;

    return (
        <Flex align="center" justify={justify} gap={10}>
            <Progress
                type="circle"
                percent={Math.round((completedCount / trackCheckList.length) * 100)}
                size={20}
            />
            <Typography.Text strong>{`${completedCount} / ${trackCheckList.length}`}</Typography.Text>
        </Flex>
    );
};

export default ChecklistProgress;
